import { Brain, Dumbbell, Leaf, Heart } from "lucide-react";
import { ScrollReveal } from "../ui/ScrollReveal";
import { ECOSYSTEM } from "../../data/content";

const ICONS = { Brain, Dumbbell, Leaf, Heart };

export const EcosystemPitch = () => {
  return (
    <section className="relative bg-[#020617] py-24 sm:py-32 px-5 sm:px-8" data-testid="ecosystem-section">
      <div className="max-w-7xl mx-auto">
        <ScrollReveal>
          <span className="font-mono-brand text-xs uppercase tracking-[0.25em] text-cyan-400">
            The Holistic Ecosystem
          </span>
          <h2 className="font-display font-extrabold uppercase text-2xl sm:text-3xl lg:text-4xl text-white mt-4 max-w-3xl leading-tight">
            When Mind, Body, Gut &amp; Lifestyle align — transformation becomes a way of life.
          </h2>
        </ScrollReveal>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5 mt-14">
          {ECOSYSTEM.map((item, i) => {
            const Icon = ICONS[item.icon];
            return (
              <ScrollReveal key={item.key} delay={i * 0.08}>
                <div
                  className="glass-card rounded-2xl p-7 h-full hover:-translate-y-1.5 hover:border-cyan-500/40 hover:shadow-[0_0_35px_rgba(0,240,255,0.12)] transition-all duration-300"
                  data-testid={`ecosystem-card-${item.key}`}
                >
                  <div className="w-12 h-12 rounded-xl bg-cyan-500/10 border border-cyan-500/20 flex items-center justify-center mb-5">
                    <Icon size={22} className="text-cyan-400" />
                  </div>
                  <h3 className="font-display font-bold text-lg text-white tracking-wide">{item.title}</h3>
                  <p className="text-sm text-slate-400 mt-2.5 leading-relaxed">{item.desc}</p>
                </div>
              </ScrollReveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
